import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HOME } from '../../../../routes/paths';
import ListView from '../../../components/views/listView';
import { MasterMessage } from '../../../../masters/masterMessages';
import {
    asyncDeleteConfigTimeFrame,
    asyncGetFrimeTime,
    asyncGetWeCallYouConfig,
    asyncGetWeCallYouConfigTimeFrame,
} from '../../../../services/weCallYouAdmin.service';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ModalConfigWeCallYou from './modalConfigWeCallYou';
import { Box, IconButton, Tooltip } from '@mui/material';
import ModalTimeFrameConfig from './modalTimeFrameConfig';
import { weekays } from './weekays';
import moment from 'moment/moment';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import { SwalCustomClass } from '../../../components/general/toastSwal/swalCustomClass';

const WeCallYouAdmin = () => {
    const navigate = useNavigate();
    const [rowConfig, setRowConfig] = useState<any>();
    const [rows, setRows] = useState<any>();
    const [rowTimeFrame, setRowTimeFrame] = useState<any>();
    const [loadingTimeFrame, setLoadingTimeFrame] = useState<boolean>(false);
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const [openConfig, setOpenConfig] = useState(false);
    const [openTimeFrame, setOpenTimeFrame] = useState(false);
    const [saveLoad, setSaveLoad] = useState<boolean>(false);
    const [timeFrameId, setTimeFrameId] = useState<string>('');
    const { weCallYouAdmin }: any = MasterMessage;

    useEffect(() => {
        if (saveLoad && page !== 0) {
            setPage(0);
            setSaveLoad(false);
            return;
        } else if (saveLoad) setSaveLoad(false);

        asyncGetWeCallYouConfig().then((body: any) => {
            if (body.items !== undefined) {
                setRowConfig(body.items);
            }
        });

        asyncGetWeCallYouConfigTimeFrame(page, pageSize)
            .then((body: any) => {
                if (body.items !== undefined) {
                    setRows(body.items.items);
                    setLengthRows(body.items.length);
                }
            })
            .finally(() => setLoading(false));

        if (timeFrameId) {
            setLoadingTimeFrame(true);
            asyncGetFrimeTime(timeFrameId)
                .then((body: any) => {
                    if (body.items !== undefined) {
                        setRowTimeFrame(body.items);
                    }
                })
                .finally(() => setLoadingTimeFrame(false));
        }
    }, [saveLoad, page, pageSize, timeFrameId]);

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const validateDataArray = (arrayData: any, result: string) => {
        let data = '';
        let dataArray: any = [];
        if (arrayData.length > 0) {
            arrayData.map((item: any, i: number) => {
                const dataItem = weekays.filter((row) => row.id === item);
                if (dataItem) {
                    dataArray = dataArray.concat(dataItem);
                    data =
                        i === arrayData.length - 1
                            ? data.concat(dataItem[0].name)
                            : data.concat(`${dataItem[0].name}${', '}`);
                }
            });
        }

        return result === 'days' ? data : dataArray;
    };

    const onCloseTimeFrame = (value: boolean) => {
        setTimeFrameId('');
        setOpenTimeFrame(value);
        setRowTimeFrame(undefined);
    };

    const editTimeFrame = (id: string) => {
        setTimeFrameId(id);
        setOpenTimeFrame(true);
    };

    const deleteTimeFrame = (id: string) => {
        Swal.fire({
            title: weCallYouAdmin.titleDelete,
            text: weCallYouAdmin.messageDelete,
            icon: 'error',
            iconColor: '#1d1d1d',
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor: '#1d1d1d',
            confirmButtonText: 'SI',
            confirmButtonColor: '#1d1d1d',
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                asyncDeleteConfigTimeFrame(id).then((body: any) => {
                    if (body.items !== undefined) {
                        SwalCustomClass.fire({
                            text: weCallYouAdmin.messageDeleteOk,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                        });
                        asyncGetWeCallYouConfigTimeFrame(page, pageSize).then(
                            (body: any) => {
                                if (body.items !== undefined) {
                                    setRows(body.items.items);
                                    setLengthRows(body.items.length);
                                }
                            }
                        );
                    } else {
                        SwalCustomClass.fire({
                            text: weCallYouAdmin[body.message],
                            icon: 'error',
                            iconColor: '#1d1d1d',
                        });
                    }
                });
            }
        });
    };

    const columns = [
        {
            field: 'start',
            headerName: 'Inicio Franja',
            minWidth: 100,
            flex: 0.2,
            type: 'dateTime',
            valueFormatter: (params: any) =>
                params?.value !== null
                    ? moment(`2023-09-13 ${params?.value}`).format('hh:mm A')
                    : null,
        },
        {
            field: 'end',
            headerName: 'Fin Franja',
            minWidth: 100,
            flex: 0.2,
            type: 'dateTime',
            valueFormatter: (params: any) =>
                params?.value !== null
                    ? moment(`2023-09-13 ${params?.value}`).format('hh:mm A')
                    : null,
        },
        {
            field: 'maxDating',
            headerName: 'Disponibilidad',
            minWidth: 100,
            flex: 0.2,
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row: any) => (
                <>
                    <Tooltip title="Editar">
                        <IconButton
                            size="small"
                            onClick={() => editTimeFrame(row.id)}
                        >
                            <EditIcon type="submit" color="primary" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <span>
                            <IconButton
                                size="small"
                                onClick={() => deleteTimeFrame(row.id)}
                            >
                                <DeleteIcon type="submit" color="primary" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </>
            ),
        },
    ];

    return (
        <>
            <ListView
                title={weCallYouAdmin.titleList}
                titleButtonAdd={'Agregar Franja'}
                startIconButtonAdd={<AddCircleIcon color="secondary" />}
                onClickAdd={() => setOpenTimeFrame(true)}
                enabledButtonGeneral={true}
                titleButtonGeneral={'Configuración'}
                startIconButtonGeneral={<AddCircleIcon color="secondary" />}
                onClickButtonGeneral={() => setOpenConfig(true)}
                onClickBack={() => navigate(HOME)}
                columns={columns}
                rows={rows}
                rowCount={lengthRows}
                disableRow={true}
                loading={loading}
                onSetPage={(paginationModel: any) => paginator(paginationModel)}
                message={
                    rowConfig && (
                        <Box mt={1}>
                            <h4>
                                <strong>
                                    Número Días Disponible: {rowConfig.maxDates}
                                </strong>
                            </h4>
                            <h4>
                                <strong>
                                    Día(s) de la semana disponible(s):{' '}
                                    {validateDataArray(rowConfig.days, 'days')}
                                </strong>
                            </h4>
                        </Box>
                    )
                }
            />
            {openConfig && (
                <ModalConfigWeCallYou
                    open={openConfig}
                    maxDates={
                        rowConfig !== undefined ? rowConfig.maxDates : undefined
                    }
                    days={
                        rowConfig !== undefined
                            ? validateDataArray(rowConfig.days, 'daysArray')
                            : undefined
                    }
                    onClose={(value) => setOpenConfig(value)}
                    onSave={(value) => setSaveLoad(value)}
                />
            )}
            {openTimeFrame && !loadingTimeFrame && (
                <ModalTimeFrameConfig
                    open={openTimeFrame}
                    onClose={(value) => onCloseTimeFrame(value)}
                    onSave={(value) => setSaveLoad(value)}
                    rowTimeFrame={rowTimeFrame}
                />
            )}
        </>
    );
};

export default WeCallYouAdmin;
